/**
 * Browser tab titles for React Navigation on web (`document.title` / native-stack `title`).
 * Route names match root stack keys; `Main` is shown as Home.
 */
const ROUTE_LABEL: Record<string, string> = {
	Main: 'Home',
	Lobby: 'Lobby',
	Ranking: 'Ranking',
	Login: 'Login',
	Settings: 'Settings',
	Invites: 'Invites',
	Messages: 'Message Center',
	BlockList: 'Block List',
	Profile: 'Profile',
	GameRules: 'Game rules',
	MyTables: 'My tables',
	VipTables: 'VIP tables',
	VipRooms: 'VIP rooms',
	Search: 'Search',
	PersonalData: 'Personal data',
	Help: 'Help',
	JoinTournaments: 'Join tournaments',
	BuyPackages: 'Buy packages',
	Tournaments: 'Tournaments',
	Tournament: 'Tournament',
	ActiveTournament: 'Active tournament',
	Room: 'Room',
	Rooms: 'Rooms',
	Game: 'Game',
	Tutorial: 'Tutorial',
	LobbyTables: 'Lobby tables',
	PaymentCallback: 'Payment',
	PaymentSuccess: 'Payment success',
	PaymentError: 'Payment error',
};

function fallbackLabel(routeName: string): string {
	return routeName
		.replace(/([A-Z])/g, ' $1')
		.replace(/^\s+/, '')
		.trim();
}

/** Full string for the browser tab, e.g. `Svara - Home`. */
export function formatSvaraWebDocumentTitle(routeName: string): string {
	const label = ROUTE_LABEL[routeName] ?? fallbackLabel(routeName);
	return `Svara - ${label}`;
}
